import React, { useState } from "react";
import "./Contact.css";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import {
  FaInstagram,
  FaWhatsapp,
  FaFacebookF,
  FaTelegramPlane,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt
} from "react-icons/fa";



const Contact = () => {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    name: "",
    country: "",
    phone: "",
    email: "",
    date: "",
    message: ""
  });

  const [status, setStatus] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // 🔥 TELEGRAM CONFIG
  const BOT_TOKEN = "8640089731:AAEKDxEOzM-9m7Unk7OlxzJbBJulS4b5h7s";
  const CHAT_ID = "8419894563";

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

    setErrors({
      ...errors,
      [e.target.name]: ""
    });
  };

  // 🔥 VALIDATION
  const validate = () => {
    let newErrors = {};

    Object.entries(form).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "This field is required";
      }
    });

    // EMAIL VALIDATION
    if (
      form.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)
    ) {
      newErrors.email = "Invalid email address";
    }

    // PHONE VALIDATION
    if (
      form.phone &&
      !/^[0-9+\s()-]{7,20}$/.test(form.phone)
    ) {
      newErrors.phone = "Invalid phone number";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      setStatus({
        type: "error",
        msg: "❌ Please fill all fields correctly."
      });

      return;
    }

    setLoading(true);

    try {

      const text = `
📩 NEW CONTACT MESSAGE

👤 Name: ${form.name}

🌍 Country: ${form.country}

📞 Phone: ${form.phone}

📧 Email: ${form.email}

📅 Date: ${form.date}

💬 Message:
${form.message}
      `;

      const response = await fetch(
        `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            chat_id: CHAT_ID,
            text: text
          })
        }
      );

      const data = await response.json();

      if (data.ok) {

        setStatus({
          type: "success",
          msg: "✅ Message sent successfully!"
        });

        alert("✅ Message sent successfully!");

        setForm({
          name: "",
          country: "",
          phone: "",
          email: "",
          date: "",
          message: ""
        });

        setErrors({});

        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });

      } else {
        setStatus({
          type: "error",
          msg: "❌ Failed to send message."
        });
      }

    } catch (error) {
      console.log(error);

      setStatus({
        type: "error",
        msg: "❌ Something went wrong."
      });

    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { key: "name", type: "text" },
    { key: "country", type: "text" },
    { key: "phone", type: "tel" },
    { key: "email", type: "email" },
    { key: "date", type: "date" },
    { key: "message", type: "textarea" }
  ];

  return (
    <section className="contact">

      <Helmet>
        <title>{t("contact.meta.title")}</title>
        <meta name="description" content={t("contact.meta.description")} />
      </Helmet>

      <div className="contact-container">

        {/* LEFT */}
        <div className="contact-left">
          <div className="profile-card compact">

            <div className="avatar">AS</div>

            <h3 className="name">
              Adhamjon Sodiqov G'ayratovich <span>✔</span>
            </h3>

            <p className="role">{t("contact.profile.role")}</p>

            <div className="stats compact-stats">
              <span>25+ yrs</span>
              <span>10 000+ guests</span>
              <span>4.9★</span>
            </div>

            <p className="languages">🇬🇧 🇫🇷 🇷🇺</p>

            <a className="btn-chat" href="https://wa.me/998917077291">
              WhatsApp
            </a>

            <div className="contact-links compact-links">
              <a href="tel:+998889178778"><FaPhoneAlt />+998 88 917 87 78</a>
              <a href="tel:+998917077291"><FaPhoneAlt />+998 91 707 72 91</a>
              <a href="mailto:adamvoyage.uzb@gmail.com"><FaEnvelope />Email</a>

              <a
                href="https://www.google.com/maps/search/Visit%20Registan%20Square,%20Samarkand,%20Uzbekistan"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaMapMarkerAlt /> Samarqand, Uzbekistan
              </a>
            </div>

            <div className="socials compact-socials">
              <a href=" "><FaInstagram /></a>
              <a href="https://wa.me/998917077291"><FaWhatsapp /></a>
              <a href="https://www.facebook.com/gayrat.qilichev.9"><FaFacebookF /></a>
              <a href="https://t.me/the_adhamjon"><FaTelegramPlane /></a>
            </div>

          </div>
        </div>

        {/* RIGHT FORM */}
        <form className="contact-form compact-form" onSubmit={handleSubmit}>

          <div className="form-header">
            <h2>📩 {t("contact.form.title")}</h2>
            <p>✈️ {t("contact.form.subtitle")}</p>
          </div>

          {status && (
            <div className={`status ${status.type}`}>
              {status.msg}
            </div>
          )}

          {fields.map((f) => (
            <label key={f.key} className="form-label">

              <span className="label-text">
                {t(`contact.form.${f.key}`)}
              </span>

              {f.type !== "textarea" ? (
                f.key === "phone" ? (
                  <div
                    className={`phone-wrapper ${errors.phone ? "error" : ""}`}
                  >
                    <PhoneInput
                      defaultCountry="uz"
                      value={form.phone}
                      onChange={(phone) =>
                        setForm({ ...form, phone })
                      }
                      disabled={loading}
                    />
                  </div>
                ) : (
                  <input
                    type={f.type}
                    name={f.key}
                    value={form[f.key]}
                    onChange={handleChange}
                    className={errors[f.key] ? "error" : ""}
                    disabled={loading}
                    placeholder={t(`contact.form.${f.key}`)}
                  />
                )
              ) : (
                <textarea
                  name={f.key}
                  value={form[f.key]}
                  onChange={handleChange}
                  className={errors[f.key] ? "error" : ""}
                  disabled={loading}
                  placeholder={t(`contact.form.${f.key}`)}
                />
              )}

              {errors[f.key] && (
                <span className="error-text">
                  {errors[f.key]}
                </span>
              )}

            </label>
          ))}

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading
              ? "⏳ Sending..."
              : "🚀 " + t("contact.form.submit")}
          </button>

        </form>

      </div>
    </section>
  );
};
export default Contact;